import { render, staticRenderFns } from "./space-grading.vue?vue&type=template&id=12d4626e&scoped=true"
import script from "./space-grading.vue?vue&type=script&lang=js"
export * from "./space-grading.vue?vue&type=script&lang=js"
import style0 from "./space-grading.vue?vue&type=style&index=0&id=12d4626e&prod&lang=less&scoped=true"
import style1 from "./space-grading.vue?vue&type=style&index=1&id=12d4626e&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12d4626e",
  null
  
)

export default component.exports